import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

import type { IconCellContentProps } from '../../types/cell-types';

export function IconCellContent({ icon, description, className }: IconCellContentProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="flex items-center justify-center text-dark [&>svg]:size-5">{icon}</span>
      {!isNil(description) && <span className="text-xs text-secondary">{description}</span>}
    </div>
  );
}
